import { useEffect } from 'react';
import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';
import { Form, TextField } from '@change/ds-forms';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { useLoginOrSignupTracking } from 'src/app/pages/loginOrSignup/shared/hooks';

import { useOtpStep } from './hooks/useOtpStep';

export const OtpStep: React.FC = () => {
	const {
		data: { otp, otpError, email },
		actions: { setOtp, submitStep, resendCode, gotoPasswordStep },
	} = useOtpStep();
	const { translate } = useI18n();
	const { trackOtpStepView, trackOtpResendClick } = useLoginOrSignupTracking();

	useEffect(() => {
		trackOtpStepView();
	}, [trackOtpStepView]);

	const handleResend = () => {
		trackOtpResendClick();
		resendCode();
	};

	return (
		<div>
			<Text as="p" size="small" className="mb-6">
				<Translate value="corgi.login_or_signup.otp.subtitle" replacements={{ email }} />
			</Text>
			<Form
				onSubmit={() => {
					void submitStep();
				}}
				data-testid="otp-form"
				data-qa="otp-form"
			>
				<TextField
					id="otp"
					type="text"
					name="otp"
					size="large"
					inputMode="numeric"
					maxLength={6}
					autoComplete="one-time-code"
					data-testid="otp-input"
					data-qa="otp-input"
					label={translate('corgi.login_or_signup.otp.input_label')}
					onChange={(value) => setOtp(value)}
					value={otp}
					isInvalid={!!otpError}
					errorMessage={otpError}
				/>
			</Form>
			<div className="mt-6">
				<Link
					as="button"
					variant="secondary"
					size="small"
					onClick={gotoPasswordStep}
					data-testid="otp-use-password"
					data-qa="otp-use-password"
				>
					<Translate value="corgi.login_or_signup.otp.use_password" />
				</Link>
			</div>
			<div className="mt-6">
				<Text as="p" size="small" className="text-typography-weak">
					<Translate value="corgi.login_or_signup.otp.resend_prompt" />{' '}
					<Link
						as="button"
						variant="secondary"
						size="small"
						onClick={handleResend}
						data-testid="otp-resend"
						data-qa="otp-resend"
					>
						<Translate value="corgi.login_or_signup.otp.resend" />
					</Link>
				</Text>
			</div>
		</div>
	);
};
